export default {
    productionAPI: "https://wesleyscripts.com/api",
    devAPI:        "http://localhost:3000/api",
    // pathAPI:       "https://wesleyscripts.com/api",
    pathAPI:       "https://dev.wesleyscripts.com/api",
    // pathAPI:       "http://localhost:3000/api",
}